import * as React from "react";
import isSafari from "utils/browserDetection";
import { Button } from "ui/components";
import downloadFileUrl from "utils/downloadFileUrl";
import { useEditorContext } from "ui/context/EditorContext";
import styles from "./EditorThumbnail.module.scss";

interface Props {
    requestScreenshot(): string | null;
}

const EditorThumbnail: React.FC<Props> = ({ requestScreenshot }) => {
    const editorContext = useEditorContext();

    const handleCreateThumbnail = async () => {
        requestScreenshot();
    };
    const handleDownloadThumbnail = () => {
        if (!editorContext.thumbnailURL) {
            return;
        }
        downloadFileUrl(editorContext.thumbnailURL, "Thumb.png");
    };

    /** @type {Thumbnail} */
    const thumbnail = editorContext.thumbnailURL;
    return (
        <div>
            {isSafari() ? (
                <div className={styles.thumbnail__preview}>
                    Safari currently does not support creating thumbnails from a
                    livestream. You can choose a thumbnail in your dashboard
                    after creating a clip.
                </div>
            ) : (
                <>
                    {thumbnail && (
                        <img
                            className={styles.thumbnail__preview}
                            alt="thumbail - preview"
                            src={thumbnail}
                        />
                    )}
                    {!thumbnail && <div className={styles.placeholder} />}
                    <div className={styles.btnbar}>
                        <Button
                            type="secondary"
                            theme="light"
                            onClick={handleCreateThumbnail}
                            disabled={!requestScreenshot}
                            icon="picture"
                        >
                            Take thumbnail
                        </Button>
                        <Button
                            type="secondary"
                            theme="light"
                            onClick={handleDownloadThumbnail}
                            icon="download"
                            disabled={!thumbnail}
                        >
                            Download
                        </Button>
                    </div>
                </>
            )}
        </div>
    );
};

export default EditorThumbnail;
